import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource/fira-sans/latin-400.css';
import '@fontsource/fira-sans/latin-500.css';
import '@fontsource/fira-sans/latin-600.css';
import '@fontsource/fira-code/latin-400.css';
import './styles.css';
import { App } from './app.js';
import { UiPreferencesProvider } from './i18n/ui-preferences.js';

window.sessionStorage.removeItem('tcode.api-token');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('TCode root element is missing');
createRoot(root).render(
  <StrictMode>
    <UiPreferencesProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </UiPreferencesProvider>
  </StrictMode>,
);
